import React from "react";
import { Paper } from "@material-ui/core";
import {
  KSelectAutocomplete,
  KSelectMulti,
  KTextInput,
} from "@kyburz/kdesign-system";

import { Config } from "../../Config";
import { hardwareTypes, simTypes } from "../../../../utils/hardwareTypes";
import { useStyles } from "./styles";

interface Props {
  config: Config;
  setConfig: (param: Partial<Config>) => void;
  selectedFileName?: string;
  setSelectedFileName?: (name: string) => void;
}

const ConfigEditingTab = ({
  config,
  setConfig,
  selectedFileName,
  setSelectedFileName,
}: Props) => {
  const classes = useStyles();

  const handleChange = (e) => {
    setConfig({ [e.target.name]: e.target.value });
  };

  const handleSelectChange = (name, value) => {
    setConfig({ [name]: value?.value });
  };

  const toBase64 = (event) =>
    new Promise((resolve, reject) => {
      const file = event?.target?.files[0];
      setSelectedFileName?.(file?.name);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
        setConfig({ contentsBase64: reader?.result as string });
      };
      reader.onerror = (error) => reject(error);
    });

  const onTypeTag = (e, tags) => {
    const value = e.target.value;
    if (value.endsWith(",")) {
      const newTag = value.trim().split(",")[0];
      setConfig({
        tags: Array.from(new Set([...tags, newTag])),
      });
    }
  };

  const onDeleteTag = (e, tags) => {
    const value = e.option.name;
    setConfig({
      tags: tags.filter((t) => t !== value),
    });
  };

  return (
    <Paper className={classes.paper}>
      <KTextInput
        label="Name"
        name="version"
        value={config?.version}
        onChange={handleChange}
        placeholder="Name"
        width="100%"
        required
      />
      <KTextInput
        label="Description"
        name="description"
        value={config?.description}
        onChange={handleChange}
        placeholder="Description"
        width="100%"
      />
      <KSelectMulti
        key="tags"
        name={"Tags"}
        placeholder={"Tags"}
        label="Tags"
        elements={[]}
        noOptionsText={"Type comma separated tag names"}
        defaultSelected={config?.tags.map((t) => ({ name: t }))}
        onType={(e) => onTypeTag(e, config?.tags)}
        onChange={(_name, _value, e) => onDeleteTag(e, config?.tags)}
        width="100%"
      />
      <KSelectAutocomplete
        label="Hardware"
        placeholder="Select Hardware"
        style={{ width: "100%" }}
        value={config?.hardwareType}
        elements={hardwareTypes}
        onChange={handleSelectChange}
        name="hardwareType"
      />
      <KSelectAutocomplete
        label="Sim type"
        required={true}
        placeholder="Select sim type"
        style={{ width: "100%" }}
        value={config?.simType}
        elements={simTypes}
        onChange={handleSelectChange}
        name="simType"
      />
      <div style={{ marginTop: 16 }}>
        <div style={{ marginBottom: 14 }}>Config File *</div>
        <label
          id="file-input-label"
          htmlFor="file-input"
          className={classes.fileInputLabel}
        >
          Select a File
          <input
            type="file"
            id="file-input"
            name="file-input"
            onChange={(event) => toBase64(event)}
            className={classes.fileInput}
          />
        </label>
        <div className={classes.fileName}>{selectedFileName}</div>
      </div>
    </Paper>
  );
};

export default ConfigEditingTab;
